import React, { Component } from 'react';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Grid,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import _ from 'lodash';
import {
  AlignedGrid, 
  QuoteComparisonExpansionPanel,
   createLoanGridElements, 
   createLoanGridLabel,
  createLoanGridElementsWithRenderer,
  RightAlignedDiv,
  createMoneyLoanGridElements,
  createPeriodLoanGridElements,
  createAbbreviatedMoneyLoanGridElements,
  QuoteComparisonExpansionSummary,
  QuoteComparisonExpansionPanelDetails,
  createMultiLineStringLoanGridElements,
  createRateLoanGridElements,
  
} from './QuoteComparisonGridElements';
import numberFormatter from 'utils/numberFormatter';

class HedgeRequirement extends Component {
  state = {
    expanded:true
  }

  handleChange = (event, expanded) => {
    this.setState({
      expanded: expanded
    });
  }

  formatHedgeValue = (hedgeType, value) => {
    if(hedgeType.indexOf("Cap") > -1){
      const money = numberFormatter.formatMoney(value, 2);
      return money;
    }
    
    if(hedgeType.indexOf("Swap") > -1){
      const rate = numberFormatter.formatRate(value, 2);
      return rate;
    }
  }

  renderHedgePremium = (field, valueProperty, hedgeTypeProperty) => {
    return (loan,placeholder) => {
      if(loan[valueProperty] && loan[valueProperty].toString().indexOf("|") > -1) {
        
        const hedgeTypes = loan[hedgeTypeProperty].split("|");
        
        return loan[valueProperty].split('|').map((value, index) => {
          let hedgeType = hedgeTypes[index];
          return !value && value !== 0 ?
                (<RightAlignedDiv key={`${field}-${index}`}>{placeholder}</RightAlignedDiv>)
                :
                (<React.Fragment key={`${field}-${index}`}>{`${this.formatHedgeValue(hedgeType, value)} ${hedgeType}`}<br /></React.Fragment>);
        });
      } else {
        let value = loan[valueProperty];
        let hedgeType = loan[hedgeTypeProperty];
        return !value && value !== 0 ?
                (<RightAlignedDiv>{placeholder}</RightAlignedDiv>)
                :
                `${this.formatHedgeValue(hedgeType, value)} ${hedgeType}`;
      }
  }
  }

  renderRate = (property) => {
    return (loan) => {
      let value = loan[property];
      if(!value && value !== 0)
        return (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>)
      return (<RightAlignedDiv>{numberFormatter.formatRate(loan[property], 2, '\u2014')}</RightAlignedDiv>)
    }
  }
  render() {
    const { loans,isCombined } = this.props;
    const { expanded } = this.state;

    return (
      <QuoteComparisonExpansionPanel onChange={this.handleChange} defaultExpanded>
        <QuoteComparisonExpansionSummary expandIcon={<ExpandMoreIcon />} expanded={expanded}>
          <Grid container direction="row" alignItems="stretch">
            {createLoanGridLabel("Hedge Requirement")}
            {expanded && createMultiLineStringLoanGridElements(loans, 'hedgeRequirementsRequiredHedgeValue', '\u2014',isCombined)}
          </Grid>
        </QuoteComparisonExpansionSummary>
        <QuoteComparisonExpansionPanelDetails>
          <AlignedGrid container direction="row" justify="flex-start" alignItems="stretch">
            {createLoanGridLabel("Hedge Premium")}
            {createLoanGridElementsWithRenderer(loans, this.renderHedgePremium('hedgePremium', 'hedgePremium', 'hedgeRequirementsRequiredHedgeValue'),'\u2014',isCombined)}
            
          </AlignedGrid>
        </QuoteComparisonExpansionPanelDetails>
      </QuoteComparisonExpansionPanel>
    )
  }
}

export default HedgeRequirement;